export type SortKeyType = number | string;

export type Comparator<T> = (a: T, b: T) => number;

/**
 * Reverses the order of a comparator
 * @param comparator Comparator to reverse
 */
export function reversed<T>(comparator: Comparator<T>): Comparator<T> {
  return (a: T, b: T) => comparator(a, b) * -1;
}

/**
 * Merges an array of comparators into a single one
 * @param comparators comparisons to run in order
 * @return A single comparator that runs comparisons in provided order
 */
export function sequenced<T>(comparators: Comparator<T>[]): Comparator<T> {
  return (a: T, b: T) =>
    comparators.map((cmp) => cmp(a, b)).find((r) => r !== 0) ?? 0;
}

export function keyFnToComparator<T>(
  keyFn: (t: T) => SortKeyType,
  reversed = false,
): Comparator<T> {
  return (a: T, b: T): number => {
    const ka = keyFn(a);
    const kb = keyFn(b);
    if (ka < kb) return reversed ? 1 : -1;
    if (kb < ka) return reversed ? -1 : 1;
    return 0;
  };
}
